import {Form, Input, Button, Modal} from 'antd';
import {useMutation} from '@apollo/client';
import {PRE_SIGN_MEDIA_URL} from 'graphql/mutations/wallet';
import {fullyDecodeURL} from 'utils/helper';
import {toast} from 'react-toastify';
import styles from './regenerateAWSURL.module.scss';

export const RegenerateAWSURL = ({isOpen, onClose}) => {
  const [form] = Form.useForm();
  const [presignMediaURL, {loading}] = useMutation(PRE_SIGN_MEDIA_URL);

  const handleSubmit = values => {
    const {awsUrl} = values;

    if (!awsUrl || !awsUrl.includes('amazonaws.com')) {
      toast.error('Please enter a valid AWS S3 URL');
      return;
    }

    try {
      // Extract bucket and filename from URL
      const parsedUrl = new URL(awsUrl);
      const bucket = parsedUrl.hostname.split('.')[0];
      const filename = decodeURIComponent(parsedUrl.pathname).substring(1);

      if (!bucket || !filename) {
        toast.error('Invalid AWS URL format');
        return;
      }

      presignMediaURL({
        variables: {
          input: {
            filename: fullyDecodeURL(filename),
            bucket,
            upload: false,
          },
        },
      })
        .then(({data: {presignMediaURL}}) => {
          if (presignMediaURL.__typename === 'Error') {
            toast.error(presignMediaURL.message);
          } else {
            const newUrl = presignMediaURL?.data?.url;
            if (newUrl) {
              window.open(newUrl, '_blank', 'noopener,noreferrer');
              toast.success('Presigned URL generated and opened in new tab');
              form.resetFields();
              onClose();
            } else {
              toast.error('Failed to generate presigned URL');
            }
          }
        })
        .catch(error => {
          toast.error('Something went wrong');
          console.error(error);
        });
    } catch (error) {
      toast.error('Invalid URL format');
      console.error(error);
    }
  };

  return (
    <Modal
      title="Regenerate AWS URL"
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={600}
      className={styles.modal}>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        className={styles.form}>
        <Form.Item
          label="AWS S3 URL"
          name="awsUrl"
          rules={[
            {
              required: true,
              message: 'Please enter an AWS S3 URL',
            },
            {
              pattern: /https?:\/\/.*\.s3.*\.amazonaws\.com\/.*/,
              message: 'Please enter a valid AWS S3 URL',
            },
          ]}
          help="Enter an expired AWS S3 URL to generate a new presigned URL">
          <Input
            placeholder="https://bucket-name.s3.region.amazonaws.com/filename"
            size="large"
          />
        </Form.Item>
        <Form.Item className={styles.formActions}>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" htmlType="submit" loading={loading}>
            Generate & Open URL
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};
